import React from "react";

I18n = window.I18n || {};
I18n.defaultLocale = "en";

// define pluralization rules
// https://github.com/fnando/i18n-js
I18n.pluralization["ru"] = function (count) {
  const mod10 = count % 10;
  const mod100 = count % 100;
  const key =
    mod10 === 1 && mod100 !== 11
      ? "one"
      : [2, 3, 4].indexOf(mod10) !== -1 && [12, 13, 14].indexOf(mod100) === -1
      ? "few"
      : mod10 == 0 || [5, 6, 7, 8, 9].indexOf(mod10) !== -1 || [11, 12, 13, 14].indexOf(mod100) !== -1
      ? "many"
      : "other";
  return [key];
};
I18n.pluralization["pl"] = function (count) {
  const mod10 = count % 10;
  const mod100 = count % 100;
  const key =
    count === 1
      ? "one"
      : [2, 3, 4].indexOf(mod10) !== -1 && [12, 13, 14].indexOf(mod100) === -1
      ? "few"
      : mod10 == 0 || [5, 6, 7, 8, 9].indexOf(mod10) !== -1 || [12, 13, 14].indexOf(mod100) !== -1
      ? "many"
      : "other";
  return [key];
};

if (I18n.translations.pl) {
  I18n.translations.pl.date.month_names = [
    null,
    "Styczeń",
    "Luty",
    "Marzec",
    "Kwiecień",
    "Maj",
    "Czerwiec",
    "Lipiec",
    "Sierpień",
    "Wrzesień",
    "Październik",
    "Listopad",
    "Grudzień",
  ];
  I18n.translations.pl.date.abbr_month_names = [
    null,
    "Sty",
    "Lut",
    "Mar",
    "Kwi",
    "Maj",
    "Cze",
    "Lip",
    "Sie",
    "Wrz",
    "Paź",
    "Lis",
    "Gru",
  ];
  I18n.translations.pl.date.day_names = [
    "Niedziela",
    "Poniedziałek",
    "Wtorek",
    "Środa",
    "Czwartek",
    "Piątek",
    "Sobota",
  ];
  I18n.translations.pl.date.abbr_day_names = ["Niedz", "Pon", "Wt", "Śr", "Czw", "Pt", "Sob"];
}

if (I18n.translations.en) {
  I18n.translations.en.date.abbr_day_names = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];
}
if (I18n.translations.ru) {
  I18n.translations.ru.date.abbr_day_names = ["ВСК", "ПНД", "ВТР", "СРД", "ЧТВ", "ПТН", "СБТ"];
}
if (I18n.translations.de) {
  I18n.translations.de.date.abbr_day_names = ["So", "Mo", "Di", "Mi", "Do", "Fr", "Sa"];
}

I18n.humanAttributeName = function humanAttributeName(modelName, attributeName, options) {
  options = options || {};
  return I18n.t("activerecord.attributes." + modelName + "." + attributeName, {
    defaultValue: I18n.t("attributes." + attributeName + "", {
      defaultValue: options.defaultValue || attributeName,
    }),
  });
};

I18n.formatRange = function formatRange(x, y) {
  x = x === "" || x === undefined ? null : x;
  y = y === "" || y === undefined ? null : y;
  if (x !== null && y !== null) {
    return I18n.t("base.from_x_to_y", { x: x, y: y });
  } else if (x !== null) {
    return I18n.t("base.from_x", { count: x });
  } else if (y !== null) {
    return I18n.t("base.to_x", { count: y });
  } else {
    return null;
  }
};

I18n.tt = function i18nTranslateToArray(translationKey, params) {
  var translationParams = {};
  Object.keys(params || {}).forEach(function (key) {
    var interpolationKey = "%{" + key + "}";
    var value = params[key];
    if (typeof value == "object" && value.props) {
      translationParams[key] = interpolationKey;
    } else {
      translationParams[key] = value;
    }
  });

  var strings = [I18n.t(translationKey, translationParams)];

  Object.keys(params || {}).forEach(function (key) {
    var newStrings = [];
    var interpolationKey = "%{" + key + "}";
    var value = params[key];
    strings.forEach(function (string) {
      if (typeof string == "string") {
        var i = string.indexOf(interpolationKey);
        if (i != -1) {
          var x = string.split(interpolationKey);
          newStrings.push(x[0]);
          newStrings.push(value);
          newStrings.push(x[1]);
        } else {
          newStrings.push(string);
        }
      } else {
        newStrings.push(string == null ? "" : string);
      }
    });
    strings = newStrings;
  });

  strings = strings.map(function (string, i) {
    if (typeof string === "object" && string.props) {
      return React.cloneElement(string, { key: i });
    }

    return string;
  });

  return strings.length === 0 ? "" : strings.length === 1 ? strings[0] : strings;
};



//////////////////
// WEBPACK FOOTER
// ./vendor/i18n/config.js
// module id = 2778
// module chunks = 1